import { ProgressSteps } from 'emerald-ui/dist/ProgressSteps';
import React from 'react';
import { ProgressBar_Root } from './ProgressBar.style';

/**
 * @typedef ProgressBarProps
 * @property {number} [currentStepIndex]
 * @property {string[]} [steps]
 */

/** @type {(props: ProgressBarProps & React.HTMLAttributes<HTMLDivElement>) => JSX.Element} */
export function ProgressBar(props) {
    const {
        currentStepIndex = 2,
        steps = ['Pickup', 'Departed', 'En Route', 'Arrived', 'Delivered'],
        ...otherProps
    } = props;

    return (
        <ProgressBar_Root {...otherProps}>
            <ProgressSteps
                currentStepIndex={currentStepIndex}
                steps={steps}
            />
        </ProgressBar_Root>
    );
}
